import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { CardTypeBreakdown } from '../../../../services/user-analytics/user-analytics.model';

@Component({
    selector: 'app-user-card-type-chart',
    templateUrl: './user-card-type-chart.component.html',
    styleUrls: ['./user-card-type-chart.component.scss'],
})
export class UserCardTypeChartComponent implements OnChanges {
    @Input() data: CardTypeBreakdown[] = [];

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
    };

    private colors = ['#3a7bd5', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((d) => d.cardType),
            datasets: [
                {
                    data: this.data.map((d) => d.count),
                    backgroundColor: this.data.map((_, i) => this.colors[i % this.colors.length]),
                },
            ],
        };
    }
}
